import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Link,
} from "react-router-dom";
import "./App.css";

import { PurchaseApprovalApprForm, PurchaseApprovalReqForm } from "./component";

// 404 component for unknown routes
const NotFound = () => {
  return (
    <div className="not-found">
      <h2>Page Not Found</h2>
      <p>The page you're looking for doesn't exist.</p>
      <Link to="/approve" className="link">
        Go to Approval Form
      </Link>
    </div>
  );
};

function App() {
  return (
    <Router>
      <div className="app">
        <main className="main">
          <Routes>
            {/* Requester submits PO */}
            <Route
              path="/request/:slug"
              element={<PurchaseApprovalReqForm />}
            />

            {/* Approver reviews */}
            <Route
              path="/approve/:slug"
              element={<PurchaseApprovalApprForm />}
            />

            {/* Default route redirects to request form */}
            <Route path="/" element={<Navigate to="/approve" replace />} />

            {/* 404 fallback route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <footer className="footer"></footer>
      </div>
    </Router>
  );
}

document.addEventListener("DOMContentLoaded", () => {
  const style = document.createElement("style");
  style.textContent = `
    a:hover {
      background-color: rgba(52, 152, 219, 0.1);
    }
  `;
  document.head.appendChild(style);
});

export default App;
